module.exports = __webpack_public_path__ + "media/theme/accout__status sent-71cefc6d.svg";